import { useMutation } from '@tanstack/react-query'
import { createWalletV2 } from 'services/WalletsService'
import { WalletType } from 'types/types'
import { WalletsCreateRequest } from 'types/wallets'

export const useCreateWalletMutation = () => {
  return useMutation({
    mutationFn: (payload: WalletsCreateRequest): Promise<WalletType> => createWalletV2(payload),
  })
}
